import { FormGroup, FormGroupProps, Radio, RadioProps } from '@agro-club/agroclub-shared'
import _ from 'lodash'
import { FormikFieldsType } from 'modules/domain/types'
import React, { FC, ReactNode } from 'react'
import { FormItemWrapper } from 'views/styled/common'
type Props = {
  formik: FormikFieldsType
  children: React.ReactElement<RadioProps<any>>[]
  field: string
  label?: ReactNode
  labelHeight?: FormGroupProps['labelHeight']
  labelWidth?: number
  horizontal?: boolean
  disableRightPadding?: FormGroupProps['disableRightPadding']
  onChange?: (value: string) => void
}

export const FormRadio: FC<Props> = ({
  label,
  children,
  field,
  formik,
  labelHeight,
  labelWidth,
  horizontal,
  disableRightPadding,
  onChange,
}) => {
  const value = _.get(formik.values, field)
  const error = _.get(formik.errors, field)
  return (
    <FormGroup
      label={label}
      labelHeight={labelHeight}
      labelWidth={labelWidth}
      error={error}
      horizontal={horizontal}
      disableRightPadding={disableRightPadding}
    >
      <FormItemWrapper size="small">
        <Radio
          onChange={(value) => {
            formik.setFieldValue(field, value)
            onChange && onChange(value)
          }}
          value={value}
        >
          {children}
        </Radio>
      </FormItemWrapper>
    </FormGroup>
  )
}
